import { LoadingButton } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useState } from 'react';
import { CmsCancelElibility } from '../../../../hooks/cancel-items-hooks';
import '../../../../styles/order-details.scss';
import { isProductTypeEPPOnly } from '../../../../utils/hdppCheck-utils';
import { getOrderActionEligibility } from '../../util/FulfillmentStatus';
export var RemorseCancel = function (_a) {
    var bopisCancelEnabled = _a.bopisCancelEnabled, _b = _a.buttonVariant, buttonVariant = _b === void 0 ? 'primary' : _b, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, handleCancelEligibilityResult = _a.handleCancelEligibilityResult, isCancelEnabled = _a.isCancelEnabled, isDFSCancelEnabled = _a.isDFSCancelEnabled, isLineItemCancelEnabled = _a.isLineItemCancelEnabled, orderDetailsData = _a.orderDetailsData, statusCode = _a.statusCode, customerType = _a.customerType;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useThdCustomer(), isLoggedIn = _d.isLoggedIn, isExchangeCustomer = _d.isExchangeCustomer;
    var isAuthTHDUser = isLoggedIn && !isExchangeCustomer;
    var getEligibility = getOrderActionEligibility(fulfillmentType, statusCode);
    /* TODO: Refactor all the cancel functionality and DRY
     */
    var handleSTHorBOSSQtyCancel = function () {
        var isSingleItemWithQuantityOne = !(fulfillmentGroup.lineItems &&
            fulfillmentGroup.lineItems.length === 1 &&
            fulfillmentGroup.lineItems[0].currentQuantity === 1);
        setLoading(true);
        CmsCancelElibility(fulfillmentGroup, orderDetailsData, isSingleItemWithQuantityOne, true, false, handleCancelEligibilityResult, customerType, isAuthTHDUser, isLineItemCancelEnabled);
        setLoading(false);
    };
    var getCancelVariantAndOnClick = function (eligibility) {
        var variant = buttonVariant;
        var onClick;
        var cancelSTHorBOSSEligibilityCheck = eligibility === null || eligibility === void 0 ? void 0 : eligibility.isCancelEligibleForSTHorBOSS;
        if (cancelSTHorBOSSEligibilityCheck && isLineItemCancelEnabled) {
            onClick = function () { return handleSTHorBOSSQtyCancel(); }; // will navigate to Cancel Items page for Qty cancel
        }
        else if (cancelSTHorBOSSEligibilityCheck && !isLineItemCancelEnabled) {
            onClick = function () {
                setLoading(true);
                CmsCancelElibility(fulfillmentGroup, orderDetailsData, false, true, false, handleCancelEligibilityResult, customerType, isAuthTHDUser, isLineItemCancelEnabled); // will open CancellationDrawer
                setLoading(false);
            };
        }
        else if (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isMAorBODFSorDFSCancelEligible) {
            onClick = function () {
                // MA Cancellation
                setLoading(true);
                CmsCancelElibility(fulfillmentGroup, orderDetailsData, false, false, false, handleCancelEligibilityResult, customerType, isAuthTHDUser);
                setLoading(false);
            }; // will open CancellationDrawer
        }
        else if (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isBopisCancelEligible) {
            variant = (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isBopisArrivedAndReadyForPickUp)
                ? 'secondary'
                : 'primary';
            onClick = function () {
                setLoading(true);
                CmsCancelElibility(fulfillmentGroup, orderDetailsData, false, false, false, handleCancelEligibilityResult, customerType, isAuthTHDUser);
                setLoading(false);
            }; // will open CancellationDrawer
        }
        else {
            return null;
        }
        return { variant: variant, onClick: onClick };
    };
    var result = getCancelVariantAndOnClick(getEligibility);
    /* check hdpps in the lineItems, within the single line item or multiple line items, if only single lineitem with hdpp do not render cancel button */
    var isHDPP = isProductTypeEPPOnly((fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) || []);
    return (React.createElement(React.Fragment, null, (isCancelEnabled || isDFSCancelEnabled || bopisCancelEnabled) &&
        !isHDPP &&
        result && (React.createElement("div", { className: "card-fix" },
        React.createElement(LoadingButton, { variant: result === null || result === void 0 ? void 0 : result.variant, onClick: result === null || result === void 0 ? void 0 : result.onClick, loading: loading, "data-testid": "test-cancel-items" }, "Cancel Items")))));
};
